import packageJson from '../package.json';

const NODE_ENV = process.env.NODE_ENV;

const __VERSION__ =
  NODE_ENV !== 'production' ? 'development' : packageJson?.version ?? 'unknown';

export { __VERSION__ as ReleaseVersion };
